import * as React from 'react';
import FontPicker from './FontPicker';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import {Col} from 'react-bootstrap';

export class FontManager extends React.Component {
  render() {
    return (
      <>
        {this.props.fontUrl && (
          <>
            <link href={this.props.fontUrl} rel={'stylesheet'} />
            <Form.Group as={Row}>
              <Form.Label column sm="2">
                Font
              </Form.Label>

              <Col sm={'2'}>
                <p
                  className="apply-font"
                  style={{
                    paddingLeft: '20px',
                    fontFamily: `"${this.props.font}"`,
                  }}
                >
                  1234567890
                </p>
              </Col>
            </Form.Group>
          </>
        )}
        {!this.props.fontUrl && (
          <FontPicker
            font={
              typeof this.props.font === 'string' ? this.props.font : 'ABeeZee'
            }
            onChange={this.props.onChange}
          />
        )}
      </>
    );
  }
}
